module.exports = __webpack_public_path__ + "images/ovrigt.f68aa99c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/ovrigt.jpg
// module id = 20079bbb
// module chunks = 10 37